export default __webpack_public_path__ + "static/vanilla-glaze-doughnut3-2892fa194855b1e1316b60928f6d2bc6.png";